import React from 'react';
import BankCard from '../../common/BankCard/BankCard';
import PhonePe from "../../../assets/icons/phonepeImg.png";
import GooglePay from "../../../assets/icons/GooglePay.png";
import BhimUPI from "../../../assets/icons/BhimUPI.png";
import BOB from "../../../assets/icons/BOBImg.png";
import HDFC from "../../../assets/icons/HDFCImg.png";
import ICICI from "../../../assets/icons/ICICIImg.png";
import Kotak from "../../../assets/icons/KotakImg.png";
import Paytm from "../../../assets/icons/paytmImg.png";
import Sbi from "../../../assets/icons/SbiImg.png";
import YesBank from "../../../assets/icons/YesBankImg.png";
import styles from './Banks.module.scss';

const Banks = () => {
  const banks = [
    { logo: PhonePe, altText: 'PhonePe' },
    { logo: Paytm, altText: 'Paytm' },
    { logo: GooglePay, altText: 'Google Pay' },
    { logo: BhimUPI, altText: 'BHIM UPI' },
    { logo: ICICI, altText: 'ICICI Bank' },
    { logo: Sbi, altText: 'SBI' },
    { logo: HDFC, altText: 'HDFC Bank' },
    { logo: BOB, altText: 'Bank of Baroda' },
    { logo: Kotak, altText: 'Kotak Bank' },
    { logo: YesBank, altText: 'Yes Bank' },
    { logo: null, altText: '& 200 other Banks', isText: true },
  ];

  // Split the banks array into two parts: one for the upper div and one for the lower div
  const upperBanks = banks.slice(0, 6);  // First 6 cards
  const lowerBanks = banks.slice(6, 11); // Remaining 5 cards

  return (
    <section className={styles.banks}>
      <div className={styles.content}>
        <h2>
          <span>EMIfy</span> powers secure transactions with <br /> 200+ banks & UPI platforms
        </h2>
        <p>
          Enable your customers to make hassle-free payments using their preferred UPI apps, net
          banking, or debit cards — all while ensuring automated payment reconciliation and
          real-time updates.
        </p>
      </div>
      <div className={styles.cardsWrapper}>
        {/* Upper div with 6 cards */}
        <div className={styles.upperDiv}>
          {upperBanks.map((bank, idx) => (
            <BankCard key={idx} logo={bank.logo} altText={bank.altText} />
          ))}
        </div>
      </div>
      <div className={styles.cardsWrapperbelow}>
        {/* Lower div with 5 cards */}
        <div className={styles.lowerDiv}>
          {lowerBanks.map((bank, idx) => (
            bank.isText ? (
              <div key={idx} className={styles.textCard}>
                <span>{bank.altText}</span>
              </div>
            ) : (
              <BankCard key={idx} logo={bank.logo} altText={bank.altText} />
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default Banks;
